module.exports = __webpack_public_path__ + "img/m.29adc250.png";